(function () {
  function initSelfiePage(root) {
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-variant-radio]'));
    var priceNodes = Array.prototype.slice.call(root.querySelectorAll('[data-current-price]'));
    var atcPrice = root.querySelector('[data-atc-price]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var mainAtc = root.querySelector('[data-main-atc]');
    var stickyVariant = root.querySelector('[data-sticky-variant]');
    var stickyAtc = root.querySelector('[data-sticky-atc]');
    var mainImage = root.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));

    function setMainImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      if (alt) mainImage.alt = alt;
    }

    function setActiveThumb(src) {
      thumbs.forEach(function (item) {
        var isActive = Boolean(src) && item.getAttribute('data-media-src') === src;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function applyVariant(radio) {
      if (!radio) return;
      var price = radio.getAttribute('data-variant-price') || '';
      var available = radio.getAttribute('data-variant-available') === 'true';

      priceNodes.forEach(function (node) {
        node.textContent = price;
      });
      if (atcPrice) atcPrice.textContent = price;
      if (stickyVariant) stickyVariant.value = radio.value;

      if (mainAtc) mainAtc.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (stickyAtc) stickyAtc.textContent = available ? 'Add to cart' : 'Sold out';

      var variantImage = radio.getAttribute('data-variant-image');
      setMainImage(variantImage, radio.getAttribute('data-variant-image-alt'));
      setActiveThumb(variantImage);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) applyVariant(radio);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActiveThumb(thumb.getAttribute('data-media-src'));
        setMainImage(
          thumb.getAttribute('data-media-src'),
          thumb.getAttribute('data-media-alt')
        );
      });
    });

    applyVariant(root.querySelector('[data-variant-radio]:checked'));
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-selfie-root]'), initSelfiePage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
